import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";

import { styled } from "@mui/material/styles";
import TextField from "@mui/material/TextField";
import IconButton from "@mui/material/IconButton";
import PrevIcon from "@mui/icons-material/ChevronLeft";
import NextIcon from "@mui/icons-material/ChevronRight";

const PaginationWrapper = styled("div")(() => ({
  position: "absolute",
  left: "50%",
  transform: "translateX(-50%)",
  // background: "#7d7d7d",
  zIndex: 1100,
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center"
}));

const Background = styled("div")(() => ({
  backgroundColor: "#404040",
  opacity: 0.7,
  position: "absolute",
  top: 0,
  left: 0,
  right: 0,
  bottom: 0
}));

const StyledInput = styled(TextField)(({ theme }) => ({
  "& .MuiInputBase-root": {
    fontSize: "1.375rem",
    borderRadius: theme.shape.borderRadius,
    backgroundColor: "white"
  },
  "& .MuiInput-input": {
    textAlign: "center",
    padding: theme.spacing(0.5, 1),
    width: "auto",
    "&:focus-visible": {
      outline: theme.outline(),
      outlineOffset: "-2px"
    }
  }
}));

const StyledIconButton = styled(IconButton)(({ theme }) => ({
  "&:focus-visible": {
    outline: theme.outline(),
    outlineOffset: "-2px"
  }
}));

function Pagination({ page, goToPrevious, goToNext, goToDestination, showGoToPrevious, showGoToNext, isTransparent }) {
  const [input, setInput] = useState("");

  function onSubmit(event) {
    goToDestination(input.trim());
    event.preventDefault();
  }

  function onInput(event) {
    setInput(event.target.value);
  }

  useEffect(() => {
    setInput(page);
  }, [page]);

  return (
    <PaginationWrapper className="pagination">
      {!isTransparent && <Background />}
      <StyledIconButton onClick={goToPrevious} disabled={!showGoToPrevious} size="large" aria-label="vorherige Seite">
        <PrevIcon htmlColor={showGoToPrevious ? "white" : "transparent"} />
      </StyledIconButton>
      <form noValidate autoComplete="off" onSubmit={onSubmit}>
        <StyledInput
          value={input}
          onInput={onInput}
          variant="standard"
          slotProps={{
            input: { disableUnderline: true },
            htmlInput: { minLength: 3, maxLength: Infinity, size: 5 }
          }}
        />
      </form>
      <StyledIconButton onClick={goToNext} disabled={!showGoToNext} size="large" aria-label="nächste Seite">
        <NextIcon htmlColor={showGoToNext ? "white" : "transparent"} />
      </StyledIconButton>
    </PaginationWrapper>
  );
}

Pagination.propTypes = {
  page: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  goToPrevious: PropTypes.func.isRequired,
  goToNext: PropTypes.func.isRequired,
  goToDestination: PropTypes.func.isRequired,
  showGoToPrevious: PropTypes.bool,
  showGoToNext: PropTypes.bool,
  isTransparent: PropTypes.bool
};

Pagination.defaultProps = {
  isTransparent: false
};

Pagination.displayName = "Pagination";

export default Pagination;
